import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useSharesTransferModal } from '../context/SharesTransferModalContext';
import SharesTransferScriptureView from './SharesTransferScriptureView';
import SharesTransferMovementsView from './SharesTransferMovemenstView';

const SharesTransferModalBody: FC = () => {
  const { data } = useSharesTransferModal();

  return (
    <Modal.Body>
      <div className="nk-modal">
        {data.scriptureView ? (
          <SharesTransferScriptureView />
        ) : (
          <SharesTransferMovementsView />
        )}
      </div>
    </Modal.Body>
  );
};

export default SharesTransferModalBody;
